// 필드 유형 옵션은 계약그룹과 동일하므로 재사용 (단일 소스 유지)
export { FIELD_TYPE_OPTIONS } from "src/pages/contractGroup/contractgroup-constant";

// 물리명(slug) 입력 규칙 - 영문 대소문자 / 숫자 / 언더스코어(_) 최대 50자 (RCR12 @Pattern 검증과 동일)
export const CUSTOM_FIELD_SLUG_MAX_LENGTH = 50;
export const CUSTOM_FIELD_SLUG_PATTERN = /^[A-Za-z0-9_]*$/;
export const CUSTOM_FIELD_SLUG_ERROR_TEXT = "영문, 숫자, _ 만 입력 가능합니다.";
export const CUSTOM_FIELD_SLUG_TOOLTIP = "임의 수정 시 일부 기능이 동작하지 않을 수 있습니다.";
export const CUSTOM_FIELD_NAME_DUPLICATED_ERROR_TEXT = "중복된 필드명입니다.";
export const CUSTOM_FIELD_OPTION_DUPLICATED_ERROR_TEXT = "중복된 옵션명입니다.";

// 커스텀 필드 관리 페이지 탭 (변경내역 미제공)
export const CUSTOM_FIELD_TABS = [
  {
    label: "기본정보",
    value: "",
  },
];

// 이용자 부가정보 목록 조건검색 옵션 (RCR31 searchType)
export const PARTNER_MEMBER_SEARCH_TYPE_OPTIONS = [
  // 미선택 상태에서 placeholder("검색 옵션")가 보이도록 빈 문자열을 쓴다. RCR31 이 받는 "ALL" 로는
  // 목록 조회 직전에 변환한다. (BaseSelect 는 value 가 truthy 일 때만 옵션을 매칭한다)
  { value: "", label: "전체" },
  { value: "MEMBER_NO", label: "회원번호" },
  { value: "PHONE_NUMBER", label: "휴대폰번호" },
  { value: "EMAIL", label: "이메일" },
  { value: "NICKNAME", label: "닉네임" },
  // TODO(BE): 계약관리 ID 검색은 RCR31 의 searchType 에 CONTRACT_MANAGE_ID 가 추가 배포된 뒤 동작한다.
  { value: "CONTRACT_MANAGE_ID", label: "계약관리 ID" },
];
